export default __webpack_public_path__ + "static/media/game3_cn_active.5857090a.png";